// @ts-nocheck
/* eslint-disable */
"use client";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Image from "next/image";
import { ImageWrapper } from "politicamente-informados-ds";
import classNames from "classnames";

export type IBlockImage = {
  attrs: {
    anchor?: string;
    align?: string;
    url?: string;
    width?: number;
    height?: number;
    alt?: string;
    caption?: string;
    href?: string;
    linkTarget?: string;
    rel?: string;
    priority?: boolean;
    className?: string;
    style?: Record<string, unknown>;
    animation?: string;
  };
};

export default function BlockImage({ attrs }: IBlockImage) {
  const {
    anchor,
    align,
    url,
    width,
    height,
    alt,
    caption,
    href,
    linkTarget,
    rel,
    priority,
    animation,
    className,
    style,
  } = attrs || {};

  return (
    <ImageWrapper
      aspectRatioHeight={
        !height || !width ? 0 : (((height as number) / width) as number) * 100
      }
      align={align}
      // caption={caption}
      href={href}
      target={linkTarget}
      rel={rel}
      className={classNames(
        className,
        animation && `elements_animated ${animation}`
      )}
      style={style}
    >
      <DisplayImage
        alt={alt}
        url={url}
        fill={true}
        sizes="100vw"
        priority={priority || false}
      />
      {animation === "masked" && <div className="elements_animated_mask"></div>}
    </ImageWrapper>
  );
}
